module.exports = __webpack_public_path__ + "img/banner.234a9675.jpg";